import Vue from 'vue'
import App from './App.vue'
import VueSession from 'vue-session'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import { setSession, clearSession } from './utils/auth'
import jwtDecode from 'jwt-decode'
import axios from 'axios'

const options = {
  persist: true
}

Vue.use(VueApexCharts)

Vue.config.productionTip = false
Vue.use(VueSession, options)

Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  vuetify,
  created () {
    this.validateSession()
  },
  onIdle () {
    this.validateSession()
  },
  onActive () {
    this.validateSession()
  },
  methods: {
    startSession (data) {
      this.$session.start()
      this.$session.set('token', this.adminToken)
      setSession(data)
      axios.defaults.headers.Authorization = `Bearer ${this.adminToken}`
    },
    endSession () {
      this.$session.clear()
      this.$session.destroy()
      clearSession()
      delete axios.defaults.headers.Authorization
      // router to push logout
    },
    resumeSession (token) {
      axios.defaults.headers.Authorization = `Bearer ${this.adminToken}`
    },
    validateSession () {
      setTimeout(() => {
        if (this.adminToken !== null) {
          try {
            const token = jwtDecode(this.adminToken, `${process.env.VUE_APP_JWT_SECRET}`)
            const time = Date.now().valueOf() / 1000
            if (token.exp < time) {
              this.endSession()
            } else {
              this.resumeSession(this.adminToken)
            }
          } catch (error) {
            this.endSession()
          }
        }
      })
    }
  },
  watch: {
    adminToken (newvalue) {
      if (newvalue) {
        this.startSession(this.adminToken)
      }
    }
  },
  computed: {
    adminToken () {
      return store.getters.getAdmintoken
    }
  },
  render: h => h(App)
}).$mount('#app')
